// @flow
export const LENGTH_DATA_ATTR = 'data-length';
export const REPLY_TO_DATA_ATTR = 'data-reply-to';
export const USER_ID_DATA_ATTR = 'data-user-id';
export const TAG = 'communityEditorMention';
const GESTALT_BLUE = '#0074e8';

export const calculateOffset = (element: any) => {
  let previousSibling = element.previousSibling;
  let offset = 0;
  while (previousSibling) {
    offset += previousSibling.textContent.length;
    previousSibling = previousSibling.previousSibling;
  }
  return offset;
};

/**
 * Utility function that will return JSON formatted string of tags to be submitted to the endpoint.
 *
 * @export
 * @param {HTMLElement} element The DOM element that contains the text to be parsed.
 * @param {Object} tags Map of user-id -> user object; user objects will be used to populate
 *    that string we are returning
 * @param {Array<User>} taggedUsers List of Users to fill the map with
 * @returns {string} JSON serialized string of tags to return to the API
 */
export const grabTags = (
  element: ?HTMLElement,
  tags: Object,
  taggedUsers?: Array<Object>,
): string => {
  let tagsToSubmit = [];
  if (taggedUsers) {
    taggedUsers.forEach((tag) => {
      tags[tag.id] = tag;
    });
  }

  if (element && element.children) {
    const children = Array.from(element.children);
    children.forEach((child) => {
      if (child.className === TAG) {
        const objectId = child.getAttribute(USER_ID_DATA_ATTR);
        const name = tags[objectId].first_name || tags[objectId].user.full_name;
        tagsToSubmit = tagsToSubmit.concat({
          object_id: objectId,
          length: name && name.length,
          offset: calculateOffset(child),
          tag_type: 1,
        });
      }
    });
  }

  return JSON.stringify(tagsToSubmit);
};

export const createMentionSpan = (user: Object, replyTo: boolean = false) => {
  const mention = document.createElement('span');
  const name = user.first_name || user.full_name;
  mention.setAttribute('style', `font-weight: bold; color: ${GESTALT_BLUE}`);
  mention.setAttribute(USER_ID_DATA_ATTR, `${user.id}`);
  mention.setAttribute(LENGTH_DATA_ATTR, `${name.length}`);
  if (replyTo) {
    mention.setAttribute(REPLY_TO_DATA_ATTR, 'true');
  }
  mention.setAttribute('class', TAG);
  mention.innerText = name;
  return mention;
};

export const parseTags = (
  tags: Array<Object>,
  taggedUsers: Array<Object>,
  text?: string,
  replyToObject: Object = {},
) => {
  let index = 0;
  let parsedText = '';

  if (replyToObject && replyToObject.user) {
    const replyName = replyToObject.user.first_name || replyToObject.user.full_name;

    if (!text || text.substring(index, replyName.length) === replyName) {
      parsedText = `${createMentionSpan(replyToObject.user, true).outerHTML} `;
      index = replyName.length;
      tags.shift();

      if (text && text.trim().length === replyName.length) {
        return parsedText;
      }
    }
  }

  if (!!text) {
    tags.forEach((tag, i) => {
      const textBefore = text ? text.substring(index, tag.offset) : '';
      index = tag.offset + tag.length;
      parsedText = `${parsedText}${textBefore}${createMentionSpan(taggedUsers[i]).outerHTML}`;
    });
    parsedText = `${parsedText}${text.substring(index)}`;
  }
  return parsedText;
};
